<mat-nav-list>
  <div class="sideHeader">
    <img class="adminImg" src="assets/images/cS-Logo.png" />
    <h2 class="header">ADMIN PORTAL</h2>
  </div>

  <mat-divider></mat-divider>

  <div class="sideMenuItems">
    <mat-list-item>
      <mat-icon mat-list-icon>home</mat-icon>
      <a id="dash" routerLink="/default" [routerLinkActive]="['is-active']" i18n>Dashboard</a>
    </mat-list-item>
    <mat-list-item>
        <mat-icon mat-list-icon>edit_square</mat-icon>
        <div class="rowElement">
          <a class="redComponent" routerLink="redlining" (isActiveChange)="onRouterLinkAction($event)" [routerLinkActive]="['is-active']" i18n>Redlining</a>
          <p *ngIf="filteredRedlinings != 0" matBadge="{{filteredRedlinings}}" matBadgeOverlap="false" matBadgePosition="after" matBadgeColor="warn"></p>
        </div>
    </mat-list-item>
    <mat-list-item>
      <mat-icon mat-list-icon>settings</mat-icon>
      <a routerLink="setting" (isActiveChange)="onRouterLinkAction($event)" [routerLinkActive]="['is-active']" i18n>Settings</a>
    </mat-list-item>
    <mat-list-item>
      <mat-icon mat-list-icon>manage_accounts</mat-icon>
      <a routerLink="config" (isActiveChange)="onRouterLinkAction($event)" [routerLinkActive]="['is-active']" i18n>Configuration</a>
    </mat-list-item>
    <mat-list-item>
      <mat-icon mat-list-icon>help_center</mat-icon>
      <a routerLink="help" (isActiveChange)="onRouterLinkAction($event)" [routerLinkActive]="['is-active']" i18n>Help</a>
    </mat-list-item>
    <mat-list-item>
      <mat-icon mat-list-icon>receipt_long</mat-icon>
      <a routerLink="log" (isActiveChange)="onRouterLinkAction($event)" [routerLinkActive]="['is-active']">Log</a>
    </mat-list-item>
  </div>

  <div class="footerDisplay">
    &copy; Copyright 2025 Jo Software Engineering GmbH | All Rights Reserved | josoftware.de
   </div>
</mat-nav-list>
